import { useProjectSettings } from '@api/settings';
import AppHeader from '@components/AppNavigation/AppHeader';
import Loader from '@components/Loader/Loader';
import React, { FC } from 'react';
import ProjectSettingsPage from './ProjectSettingsPage';

const ProjectSettingsSkeleton: FC = () => {
	const { isLoading, data } = useProjectSettings();
	return (
		<>
			<AppHeader translation="pages.projectSettings.title" />
			<Loader isLoading={isLoading} variant="settings">
				<ProjectSettingsPage data={data} />
			</Loader>
		</>
	);
};

export default ProjectSettingsSkeleton;
